// AUTO-GENERATED by scripts/gen-version.ts — do not edit by hand.
// Mirrors the "version" field in package.json (shown on the title screen).
export const APP_VERSION = "0.1.1";
